const NavBarModule = {
    namespaced: true,
    state: () => ({
        isShowUserWidget: true,
    }),
    getters: {
        getIsShowUserWidget (state) {
            return state.isShowUserWidget
        },
    },
    mutations: {
        setIsShowUserWidget(state, payload) {
            state.isShowUserWidget = payload
        },
    },
    actions: {
        setIsShowUserWidget (context, payload) {
            context.commit('setIsShowUserWidget', payload);
        },
    },
}

export default NavBarModule;
